/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GuestRoomReadAttributesThumbnail } from './guest-room-read-attributes-thumbnail';
/**
 * 
 * @export
 * @interface MeetingRoomReadAttributes
 */
export interface MeetingRoomReadAttributes {
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    availabilityStatus?: MeetingRoomReadAttributesAvailabilityStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomReadAttributes
     */
    available: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    capacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    ceilingHeight?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomReadAttributes
     */
    exterior?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    floor?: string | null;
    /**
     * Custom object ordering position
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    index?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    immersiveUrl: string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    roomHeight?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    roomLength?: number;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    roomWidth?: number;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    slug?: string;
    /**
     * 
     * @type {number}
     * @memberof MeetingRoomReadAttributes
     */
    surfaceMeters?: number;
    /**
     * 
     * @type {GuestRoomReadAttributesThumbnail}
     * @memberof MeetingRoomReadAttributes
     */
    thumbnail: GuestRoomReadAttributesThumbnail;
    /**
     * 
     * @type {string}
     * @memberof MeetingRoomReadAttributes
     */
    uuid?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRoomReadAttributes
     */
    includedInOrders?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum MeetingRoomReadAttributesAvailabilityStatusEnum {
    Disabled = 'disabled',
    Private = 'private',
    Public = 'public'
}

